module.exports = __webpack_public_path__ + "static/media/v38.c8943218.mp4";